import React from 'react';
import {
  BANKING_DEFAULTS_DESCRIPTION_TEXT,
  BANKING_DEFAULTS_DESCRIPTION_TITLE,
} from '../../../constants';
import { BaseDescription } from '../../CustomizationForm/BaseDescription';

export const BankingDefaultsSettingsDescription: React.FC = () => (
  <BaseDescription
    title={BANKING_DEFAULTS_DESCRIPTION_TITLE}
    descriptions={BANKING_DEFAULTS_DESCRIPTION_TEXT}
  />
);
